const hasSupportedPaymentMethod = ({ availablePaymentMethods }) => {
  return availablePaymentMethods.length > 0;
};

export default hasSupportedPaymentMethod;
